import { UserUserNameFollowingsGetInputModel } from "../../api/v1/user/[user_name]/followings/GetInputModel"
import { GetUserUserNameFollowings } from "../../api/v1/user/[user_name]/followings/get"

export const fetchUserFollowsCount = (
  userDisplayName: string,
): Promise<number> => {
  const model = new UserUserNameFollowingsGetInputModel(userDisplayName)

  return GetUserUserNameFollowings(model)
}
